module.exports = __webpack_public_path__ + "assets/media/day14.4b0b1a2b.mp3";